const React = require('react');
const createReactClass = require('create-react-class');
const _ = require('lodash');
const assign = require('object-assign');
const FuzzyReaction = require('../../bootstrap').FuzzyReaction;
const Table = FuzzyReaction.Components.Visualization.Tables.Table;
const Paginator = FuzzyReaction.Components.Visualization.Pagination.PaginatedButtons;
const PerPageSelector = FuzzyReaction.Components.Visualization.Pagination.PerPageSelector;
const PageSearch = FuzzyReaction.Components.Visualization.PageSearch;
const Modal = FuzzyReaction.Components.Global.Modal;
const Column = FuzzyReaction.Components.PageStructure.Column;
const Row = FuzzyReaction.Components.PageStructure.Row;
const AddAction = FuzzyReaction.Components.ResourceBinding.CreateResourceAction;
const ResourceActions = FuzzyReaction.Actions.ResourceActions;
const Form = FuzzyReaction.Components.ResourceBinding.Form.Form;
const Spinner = FuzzyReaction.Components.Global.Spinner;
const TracksStore = require('../../stores/TracksStore');
const CastManagementMixin = require('../cast-library/components/CastManagementMixin');

const MusicLibraryPage = createReactClass({
    displayName: 'MusicLibraryPage',

    mixins: [CastManagementMixin],

    getInitialState: function () {
        return {
            currentPageData: [],
            workingResource: {},
            openDeactivateModal: false,
            openCreateModal: false,
            openEditModal: false
        }
    },

    /**
     * Set up resource actions
     */
    resourceAction: new ResourceActions('tracks'),

    /**
     * Resource action options
     */
    getOptions: {
        modifiers: {
            include: ['casts.instructor'],
            sort: {
                id: 'desc'
            },
            pagination: {
                per_page: '50'
            },
            other: {
                show_deleted: true
            }
        },
        dataNode: 'data',
        refresh: 'list'
    },

    sendOptions: {
        modifiers: {
            include: ['casts.instructor'],
            sort: {
                id: 'desc'
            },
            pagination: {
                per_page: '50'
            },
            other: {
                show_deleted: true
            }
        },
        dataNode: 'data',
        refresh: 'list'
    },

    /**
     * Fire an action to request data from the API
     */
    requestTableData: function (modifiers) {
        // Merge modifiers with already present ones
        this.getOptions.modifiers = assign(this.getOptions.modifiers, modifiers, {});

        this.resourceAction.listResource(this.getOptions);
    },

    formKey: 'addTrack',

    /**
     * Register event listeners and fire request for data
     */
    componentDidMount: function () {
        this.requestTableData();

        this.changeListener = this._onChange;
        TracksStore.addChangeListener(this.changeListener);
    },

    /**
     * Deregister an event listener
     */
    componentWillUnmount: function () {
        TracksStore.removeChangeListener(this.changeListener);
    },

    /**
     * Handle changes in data and request paginated data
     *
     * @private
     */
    _onChange: function () {
        this.setState({
            currentPageData: TracksStore.getResourceListData()
        });
    },

    /**
     * @param action
     * @param resource
     */
    handleAction: function (action, resource) {
        switch (action) {
            case 'sort':
                this.requestTableData(resource);
                break;
            case 'edit':
                const resourceCopy = JSON.parse(JSON.stringify(resource))
                // Delete the casts property, as we want to make sure we don't overwrite cast data when saving.
                delete resourceCopy.casts
                this.setState({
                    openEditModal: true,
                    workingResource: resourceCopy,
                    resourceOperation: action
                });
                break;
            case 'deactivate':
                this.setState({
                    openDeactivateModal: true,
                    workingResource: resource,
                    resourceOperation: action
                });
                break;
            case 'activate':
                this.activateTrack({id: resource.id});
                break;
            case 'create':
                this.props.history.push('/music-library/add-track-manually');
                break;
        }
    },

    /**
     * Fire the update track action
     */
    updateTrack: function () {
        if (this.state.workingResource.is_dmca_restricted == null) {
            this.state.workingResource.is_dmca_restricted = 0
        }
        this.resourceAction.updateResource(this.state.workingResource, this.sendOptions);
    },

    /**
     * Fire the deactivate track action
     */
    deactivateTrack: function () {
        this.resourceAction.deactivateResource(this.state.workingResource, this.getOptions);
    },

    /**
     * Fire the activate track action
     */
    activateTrack: function (track) {
        track.deleted_at = null;
        this.resourceAction.updateResource(track, this.getOptions);
    },

    /**
     * Close all modals and reset the working resource
     */
    closeModal: function () {
        this.setState({
            openCreateModal: false,
            openEditModal: false,
            openDeactivateModal: false,
            workingResource: {}
        });
    },

    tableKeys: {
        "ID": "id",
        "Artist": "artist",
        "Track Title": "title",
        "Album": "album",
        "Album Artist": "album_artist",
        "Track ISRC": "isrc",
        "Marketing Label": "marketing_label",
        "Duration": "duration",
        "DMCA": "is_dmca_restricted"
    },

    /**
     * List casts that will be affected when a track is deactivated
     *
     * @param track
     * @returns {*}
     * @private
     */
    _buildAffectedCastsList: function (track) {
        if (typeof track.casts === 'undefined') {
            return;
        }

        if (track.casts.length === 0) {
            return <p>No casts will be affected</p>;
        }

        return track.casts.map(function (cast) {
            return <p><u><a href={'../cast-library/' + cast.id}
                            target="_blank">Cast {cast.id}</a></u>: {cast.instructor.name}'s {cast.title}</p>
        });
    },

    render: function () {
        const toMinutesString = this.toMinutesString;
        const tableOptions = {
            actionableRows: true,
            actions: ['edit:primary', 'deactivate:danger'],
            actionsCallback: this.handleAction,
            sortable: ['id', 'artist', 'title', 'album', 'album_artist', 'isrc', 'marketing_label', 'is_dmca_restricted'],
            mutators: {
                weight: function () {
                    return '@todo';
                },
                duration: function (value) {
                    return toMinutesString(value);
                },
                is_dmca_restricted: function (value) {
                    return value === 1 ? 'Yes' : 'No';
                }
            }
        };
        return (
            <div id="page-wrapper">
                <div id="page-content">
                    <div id="content"/>
                    <Row classes="align-items-center">
                        <Column grid="lg" size="8">
                            <h1 className="page-header">Music Library</h1>
                        </Column>

                        <Column grid="lg" size="4">
                            <div className="page-header">
                                <PageSearch actionMethod={this.requestTableData}
                                            searchable={['title', 'artist', 'album', 'album_artist', 'isrc', 'marketing_label']}/>
                            </div>
                        </Column>
                    </Row>
                    <Row>
                        <Column grid="lg" size="12">
                            {this.state.currentPageData.length < 1 && (
                                <Spinner type="spinner" text="Loading tracks.." classes="music-library-loader"/>
                            )}

                            {this.state.currentPageData.length >= 1 && (
                                <Table data={this.state.currentPageData}
                                       dataKeys={this.tableKeys}
                                       title={'Tracks'} options={tableOptions}/>

                            )}
                        </Column>
                    </Row>
                    <Row>
                        <Paginator actionMethod={this.requestTableData}/>
                        <PerPageSelector actionMethod={this.requestTableData}/>
                    </Row>
                </div>

                <Modal openWhen={this.state.openDeactivateModal}
                       title="Deactivate Track?" closeText="Close"
                       saveText="Deactivate" afterClose={this.closeModal}
                       beforeSave={this.deactivateTrack}
                       afterSave={this.closeModal}>
                    <p>You’re about to deactivate a track. This will cause casts that use it to break. Are you sure you
                        wish to continue&#63;</p>
                    <p>The following casts will be affected:</p>
                    {this._buildAffectedCastsList(this.state.workingResource)}
                </Modal>

                {this.state.openEditModal && (
                    <Modal openWhen={this.state.openEditModal} options={{width: '50%'}}
                           title="Edit Track"
                           closeText="Close" saveText="Save"
                           afterClose={this.closeModal}
                           beforeSave={this.updateTrack}
                           afterSave={this.closeModal}>
                        <Row>
                            <Column grid="lg" size="12" classes="edit_track_data">
                                <Form key="editTrack" formKey={this.formKey}
                                      bindResource={this.state.workingResource}>
                                    <Form.Input fieldKey="artist" type="text" label="Artist" placeholder="Artist"
                                                limit={120} validations="isLength:4:120" required={true}/>
                                    <Form.Input fieldKey="title" type="text" label="Track Title" placeholder="Name"
                                                limit={120} validations="isLength:4:120" required={true}/>
                                    <Form.Input fieldKey="album" type="text" label="Album" placeholder="Album"
                                                limit={120} validations="isLength:4:120" required={true}/>
                                    <Form.Input fieldKey="album_artist" type="text" label="Album Artist"
                                                placeholder="Name"
                                                limit={120} validations="isLength:4:120" required={true}/>
                                    <Form.Input fieldKey="isrc" type="text" label="Track ISRC" placeholder="Artist"
                                                limit={120} validations="isLength:4:120" required={true}/>
                                    <Form.Input fieldKey="marketing_label" type="text" label="Marketing Label"
                                                placeholder="Marketing Label" limit={120} validations="isLength:4:120"
                                                required={true}/>
                                    <Form.Checkbox fieldKey="is_dmca_restricted"
                                                   label="DMCA Restriction"
                                                   options={[{
                                                       name: 'isDmcaRestricted',
                                                       value: 1,
                                                       label: "DMCA Restricted"
                                                   }]}/>
                                </Form>
                            </Column>
                        </Row>
                    </Modal>
                )}

                <AddAction createResource={this.handleAction}>
                    <Modal openWhen={this.state.openCreateModal} options={{width: '60%'}}
                           title="Add Track"
                           closeText="Close" saveText="Save"
                           afterClose={this.closeModal}
                           beforeSave={this.createGenre}
                           afterSave={this.closeModal}>
                    </Modal>
                </AddAction>
            </div>
        )
    },
});

module.exports = MusicLibraryPage;
